// ui/mui/core/src/Box.tsx
import { Box as MUIBox, BoxProps } from '@mui/material';
export const Box = (props: BoxProps) => <MUIBox data-testid="box" {...props} />;
